import React, {Fragment} from 'react'
import {useParams} from 'react-router-dom'
import useOrganisation from 'admin/hooks/useOrganisation'
import InputField from 'admin/components/shared/InputField'
import useStateObject from 'admin/hooks/useStateObject'
import useEffect from 'admin/hooks/useEffect'
import Flash from 'admin/components/shared/Flash'
import Header from './shared/Header'
import ModalLink from './shared/ModalLink'
import useDocument from '../hooks/useDocument'
import ColorPickerField from './shared/ColorPickerField'

export default () => {
  const {organisationID} = useParams()
  const {organisation, errors, update} = useOrganisation(organisationID)
  const [form, setForm] = useStateObject(organisation)
  useDocument({title: `Edit ${organisation.internalName}`})

  useEffect(() => setForm(organisation), [organisation])

  const handleUpdate = () => update(form)

  return (
    <Fragment>
      <Flash />

      <Header title={`Edit ${organisation.internalName}`}>
        <button className='button is-primary' onClick={handleUpdate}>
          Save
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <div className='field is-spaced is-grouped'>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='internalName'
                label='Internal name'
                value={form.internalName || ''}
                onChange={setForm}
                errors={errors.internalName}
              />
            </div>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='externalName'
                label='External name'
                value={form.externalName || ''}
                onChange={setForm}
                errors={errors.externalName}
              />
            </div>
          </div>
          <div className='field is-spaced'>
            <div className='control'>
              <label htmlFor='internalColor' className='label is-small'>
                Colour
              </label>
              <ColorPickerField name='internalColor' value={form.internalColor || ''} onChange={setForm} />
            </div>
          </div>
          <div className='field is-spaced'>
            <div className='control'>
              <InputField
                type='text'
                label='GST number'
                name='gstNumber'
                value={form.gstNumber || ''}
                onChange={setForm}
                errors={errors.gstNumber}
              />
            </div>
          </div>

          <div className='field is-spaced'>
            <label className='label is-small'>Payment details</label>
            <p className='help'>These details are appended to invoices and statements</p>
            <div className='control'>
              <div className='buttons'>
                {organisation.paymentDetails?.map((paymentDetail, i) => (
                  <ModalLink
                    key={i}
                    modal='payment-detail'
                    params={{paymentDetailId: paymentDetail.id}}
                    className='button is-dark is-small'>
                    {paymentDetail.name}
                  </ModalLink>
                ))}
                <ModalLink modal='new-payment-detail' className='button is-light is-small'>
                  Add Payment Detail
                </ModalLink>
              </div>
            </div>
          </div>

          <div className='field is-spaced'>
            <div className='control'>
              <div className='field is-grouped'>
                <div className='control is-expanded'>
                  <InputField
                    type='number'
                    label='Next account number'
                    name='customerNumbersSequence'
                    value={form.customerNumbersSequence || 0}
                    onChange={setForm}
                    errors={errors.customerNumbersSequence}
                    min={organisation.customerNumbersSequence}
                  />
                </div>
                <div className='control is-expanded'>
                  <InputField
                    type='number'
                    label='Next invoice number'
                    name='invoiceNumbersSequence'
                    value={form.invoiceNumbersSequence || 0}
                    onChange={setForm}
                    errors={errors.invoiceNumbersSequence}
                    min={organisation.invoiceNumbersSequence}
                  />
                </div>
              </div>
            </div>
            <span className='help'>Be careful changing these values. The number sequence cannot be decremented.</span>
          </div>
          <div className='field is-spaced'>
            <div className='control'>
              <InputField
                type='text'
                label='Reply-to email'
                name='replyToEmail'
                value={form.replyToEmail || ''}
                onChange={setForm}
                errors={errors.replyToEmail}
              />
            </div>
          </div>
          <div className='field is-spaced'>
            <div className='control'>
              <InputField
                type='textarea'
                name='emailDisclaimer'
                value={form.emailDisclaimer || ''}
                onChange={setForm}
                errors={errors.emailDisclaimer}
                rows={6}
              />
            </div>
            <span className='help'>This text is appended to invoice and statement emails</span>
          </div>
        </div>
      </section>
    </Fragment>
  )
}
